import createRoute from '@widesk-ui/tools/createRoute';
import CodeModel   from '@models/code/CodeModel';

export default createRoute.dashboard('/codes', 'shop', 'CodeDashboard', CodeModel.localize());
